import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-image.reducer';

export const ActivityImageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityImageEntity = useAppSelector(state => state.activityImage.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityImageDetailsHeading">
          <Translate contentKey="activitiesApp.activityImage.detail.title">ActivityImage</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityImageEntity.id}</dd>
          <dt>
            <span id="activityImage">
              <Translate contentKey="activitiesApp.activityImage.activityImage">Activity Image</Translate>
            </span>
          </dt>
          <dd>
            {activityImageEntity.activityImage ? (
              <div>
                {activityImageEntity.activityImageContentType ? (
                  <a onClick={openFile(activityImageEntity.activityImageContentType, activityImageEntity.activityImage)}>
                    <img
                      src={`data:${activityImageEntity.activityImageContentType};base64,${activityImageEntity.activityImage}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {activityImageEntity.activityImageContentType}, {byteSize(activityImageEntity.activityImage)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="name">
              <Translate contentKey="activitiesApp.activityImage.name">Name</Translate>
            </span>
          </dt>
          <dd>{activityImageEntity.name}</dd>
          <dt>
            <span id="imageShortDescription">
              <Translate contentKey="activitiesApp.activityImage.imageShortDescription">Image Short Description</Translate>
            </span>
          </dt>
          <dd>{activityImageEntity.imageShortDescription}</dd>
          <dt>
            <span id="imageDescription">
              <Translate contentKey="activitiesApp.activityImage.imageDescription">Image Description</Translate>
            </span>
          </dt>
          <dd>{activityImageEntity.imageDescription}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityImage.activity">Activity</Translate>
          </dt>
          <dd>{activityImageEntity.activity ? activityImageEntity.activity.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity-image" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-image/${activityImageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityImageDetail;
